








































































































import {
  BSidebar,
  BSpinner,
  BForm,
  BButton,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormFile,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { PlanningPrevisionnel, UpdatePlanningPrevisionnelModel } from '../../../api/models/planningsPrevisionnels/planningPrevisionnel';
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BSidebar,
    BCol,
    BSpinner,
    BButton,
    BFormInput,
    BForm,
    BFormGroup,
    BFormFile,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class UpdatePlanningPrevisionnel extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdatePlanningPrevisionnelSidebarActive!: boolean;
  @Prop({ required: true }) planningPrevisionnelId!: string;

  loading = false;
  required = required;
  loadingPlanningPrevisionnel = false;
  isAddFileEnabled = false;

  planningPrevisionnel: UpdatePlanningPrevisionnelModel = {};

 async created() {
    await this.$http.myressif.entreprises
      .getPlanningPrevisionnelById(
        this.$route.params.id,
        this.planningPrevisionnelId
      )
      .then((res: PlanningPrevisionnel) => {
        this.planningPrevisionnel = res;
        this.loadingPlanningPrevisionnel = true;
      });
  }

  resetForm() {
    this.planningPrevisionnel = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .updatePlanningPrevisionnelEntreprise(
        this.$route.params.id,
        this.planningPrevisionnel.id,
        this.planningPrevisionnel
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du planning prévisionnel",
            text: "Planning prévisionnel modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-plannings-previsionnels");
        this.$emit("update:is-update-planning-previsionnel-sidebar-active", false);
        this.loading = false;
        this.isAddFileEnabled = false;
      });
  }
}
